<template>
  <el-select v-model="selected" v-bind="$attrs" v-on="$listeners" @clear="clearSelect">
    <el-option v-for="item in []" :key="item.value" :label="item.label" multiple collapse-tags :value="item.value">
    </el-option>
    <div slot="empty" class="custom-tree__box">
      <!-- 按标签选择人员：点击链接打开弹窗（弹窗内标签筛选+勾选人员，回填到本控件） -->
      <div v-if="labelSelect" class="custom-tree__label-filter">
        <el-link type="primary" :underline="false" @click.stop="openPersonDialog">按组织标签筛选</el-link>
      </div>
      <!-- 按标签选择人员弹窗 -->
      <sales-person-select-dialog
        v-model="personDialogVisible"
        :label-options="innerLabelOptions"
        :selected-ids="checkedValues"
        title="按组织标签筛选人员"
        @confirm="onPersonConfirm" />
      <el-input placeholder="未显示全部选项，可筛选" v-model="filterText" clearable class="custom-tree__search" @input="inputChange" v-if="(items && items.length>10) || (showFilter && items && items.length>0)">
        <el-button slot="prepend"></el-button>
      </el-input>
      <template v-if="items && items.length">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" :disabled="readonly || disableList.length > 0">{{selectText}}</el-checkbox>
        <el-checkbox-group v-model="checkedValues" @change="handleCheckedChange" :disabled="readonly">
          <template v-if="isLabelMode">
            <!-- 标签模式：按类型分组 + 色点（营销/红包标签硬圈选） -->
            <div v-for="g in labelGroupedOptions" :key="'g' + g.typeId" class="ms-label-group">
              <div class="ms-label-group-title">{{ g.typeName || '未分类' }}<span class="ms-label-group-count">{{ g.items.length }}</span></div>
              <el-checkbox v-for="item in g.items" :label="item[props.value]" :key="item[props.id || props.value]" :disabled="disableList.includes(item[props.value])">
                <span class="ms-label-opt">
                  <i class="ms-label-dot" :style="{ background: item.color || '#409EFF' }"></i>
                  <span class="ms-label-name">{{ item[props.label] || item[props.value] }}</span>
                </span>
              </el-checkbox>
            </div>
          </template>
          <template v-else>
            <el-checkbox v-for="item in options" :label="item[props.value]" :key="item[props.id || props.value]" :disabled="disableList.includes(item[props.value])">
              <span :class="{'custom-tree__delete': judgeDisableStatus(item)}" v-if="props.disabledValue!==undefined">{{ item[props.label] || item[props.value] }}</span>
              <span v-else>{{ item[props.label] || item[props.value] }}</span>
            </el-checkbox>
          </template>
        </el-checkbox-group>
      </template>
      <template v-else>
        <div class="center">
          暂无数据
        </div>
      </template>
    </div>
  </el-select>
</template>

<script>
import { tool } from '@/utils'
export default {
  name: 'yblMultiSelect',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    items: {
      type: Array | Object,
      default: () => []
    },
    checked: {
      type: Array | String,
      default: () => []
    },
    max: { // 最大显示条数
      type: String | Number,
      default: () => 20
    },
    maxSelect: { // 可勾选的最大数量（0/不传=不限制）。超出时本次勾选不生效并触发 over-max，不影响其他调用方
      type: [String, Number],
      default: 0
    },
    props: {
      type: Object,
      default () {
        return { label: 'label', id: 'id', value: 'value', disabled: 'status', disabledValue: '9' } // disabled 禁用字段，disabedValue 禁用字段对应值 （用于删除线）
      }
    },
    selectedAll: { // 多选的场景 （是否全选）
      type: Boolean,
      default: () => false
    },
    selectText: { // 全选（文本配置）
      type: String,
      default: () => '全选'
    },
    readonly: { // 是否只读
      type: Boolean,
      default: () => false
    },
    showFilter: { // 是否显示搜索框 车险政策可选工号少于十条需要显示
      type: Boolean,
      default: () => true
    },
    disableList: { // 需要禁用的选项 有数据是,需要禁用全选
      type: Array,
      default: () => []
    },
    labelSelect: { // 标签筛选：默认关闭，仅「按组织标签筛选人员」等明确场景显式 :label-select="true" 开启（WZPE-46980）
      type: Boolean,
      default: () => false
    },
    labelOptions: { // 标签选项列表（labelSelect 开启时使用）
      type: Array,
      default: () => []
    },
    labelProps: { // 标签选项字段映射
      type: Object,
      default: () => ({ label: 'labelName', value: 'labelId' })
    }
  },
  data () {
    return {
      selected: '',
      filterText: '',
      isIndeterminate: false,
      checkAll: false,
      checkedValues: [],
      lastValidValues: [], // 上一次未超限的已选项（maxSelect 开启时用于超限回退）
      isFilter: false,
      filterResult: [], // 筛选后的结果
      defaultCheckedKeys: [], // 默认选中项目
      options: [],
      originItems: [],
      selectedLabelIds: [],
      innerLabelOptions: [],
      labelFiltering: false,
      personDialogVisible: false
    }
  },
  created () {
    this.originItems = [...(this.items || [])]
    // 2026-08-31 WZPE-46980 优化：标签选项懒加载，点击「按组织标签筛选」链接时才获取，避免进页面即调 salesLabel/queryAll
    // this.initLabelOptions()

    let checked = (this.checked && (Array.isArray(this.checked) ? this.checked : this.checked.split(','))) || []
    console.log('🚀 ~ file: MultiSelect.vue:91 ~ created ~ checked', checked)
    this.checkedValues = [...checked]
    this.lastValidValues = [...checked]
    this.initOptions(this.originItems)
    this.checkedChange(this.checkedValues, false)
  },
  mounted () {
    /* let _this = this
    this.$nextTick(() => {
      _this.$once('hook:beforeDestroy', () => {
        console.time(`MultiSelect destroy ${_this.$attrs.placeholder}`)
      })
      _this.$once('hook:destroyed', () => {
        console.timeEnd(`MultiSelect destroy ${_this.$attrs.placeholder}`)
      })
    }) */
  },
  computed: {
    // 标签模式：props.label==='labelName'（营销/红包标签硬圈选等），按类型分组 + 色点展示
    isLabelMode () {
      return !!(this.props && this.props.label === 'labelName')
    },
    labelGroupedOptions () {
      const groups = []
      const map = {}
      ;(this.options || []).forEach(item => {
        const tid = item.typeId || 'none'
        if (!map[tid]) {
          map[tid] = { typeId: tid, typeName: item.typeName || '未分类', items: [] }
          groups.push(map[tid])
        }
        map[tid].items.push(item)
      })
      return groups
    }
  },
  methods: {
    inputChange (val) {
      // console.log(this.$attrs['filter-method'])
      this.isFilter = !!val
      this.debounce()(this)
    },
    debounce: tool.debounce(function (that) {
      that.getOptions()
    }, 200, this),
    getOptions () {
      // 以搜索框当前内容为准（不再直接采信入参）：清空/关闭后即使有延时任务带着旧关键字触发，也不会把筛选结果刷回来
      const keyword = `${this.filterText || ''}`.toLowerCase()
      if (keyword) {
        this.isFilter = true
        // 兜底 label 为 null/非字符串的情况，避免 toLowerCase 报错
        this.filterResult = this.originItems.filter(item => `${item[this.props.label] || ''}`.toLowerCase().indexOf(keyword) !== -1)
        this.options = this.filterResult// .filter((item, index) => index < +this.max)
      } else {
        this.isFilter = false
        this.initOptions(this.originItems)
      }
      this.checkAll = this.checkedValues && this.checkedValues.length > 0 && !this.options.some(item => !this.checkedValues.includes(`${item[this.props.value]}`))
    },
    // maxSelect 开启时的超限判断
    isOverMax (len) {
      const max = +this.maxSelect
      return max > 0 && len > max
    },
    // 超限时：不接受本次勾选，回退到上一次合法选择，并通知父组件提示
    rejectOverMax (count) {
      this.checkedValues = [...this.lastValidValues]
      const field = this.props.value
      const checkedSet = new Set((this.checkedValues || []).map(String))
      const allChecked = this.options.length > 0 && this.options.every(item => checkedSet.has(`${item[field]}`))
      this.checkAll = allChecked
      this.isIndeterminate = !allChecked && this.checkedValues.length > 0
      this.$emit('over-max', { max: +this.maxSelect, count: count || 0 })
    },
    clearSelect () {
      this.filterText = ''
      this.isFilter = false
      this.checkedValues = []
      this.lastValidValues = []
      this.checkAll = false
      this.isIndeterminate = false
      // 清空后必须把下拉选项恢复成全量，否则重新打开下拉仍是上一次搜索命中的结果
      this.initOptions(this.originItems)
      this.checkedChange(this.checkedValues)
    },
    async initLabelOptions () {
      if (!this.labelSelect) return
      if (this.labelOptions && this.labelOptions.length) {
        this.innerLabelOptions = this.labelOptions
        return
      }
      // 已加载过则复用（避免重复请求）
      if (this.innerLabelOptions && this.innerLabelOptions.length) {
        return
      }
      try {
        const res = await this.$store.dispatch('salesLabelQueryAll', { partnerId: this.getPartnerId() })
        this.innerLabelOptions = (res && res.data) || []
      } catch (e) {
        this.innerLabelOptions = []
      }
    },
    getPartnerId () {
      const user = this.$store.getters.CUSTOMER_LOGINCUSTOMER
      return (user && user.data && user.data.PartnerId) || ''
    },
    async openPersonDialog () {
      // 懒加载：点击链接时获取标签选项（首次 await 后弹窗内标签下拉即可直接使用；失败时弹窗自身有兜底重取）
      await this.initLabelOptions()
      this.personDialogVisible = true
    },
    // 弹窗确认：选中的 customerId 回填为本控件已选项（合并去重）
    onPersonConfirm (customerIds) {
      if (!customerIds || !customerIds.length) {
        return
      }
      const merged = Array.from(new Set([...this.checkedValues.map(String), ...customerIds.map(String)]))
      // 超出可选上限：不回填
      if (this.isOverMax(merged.length)) {
        this.$emit('over-max', { max: +this.maxSelect, count: merged.length })
        return
      }
      this.checkedValues = merged
      this.lastValidValues = [...merged]
      this.checkedChange(merged)
      this.$emit('label-change', merged)
    },
    checkedChange (items, emit = true) {
      console.log('this.items = ', items, this.options, this.originItems)
      this.selected = ''
      let _data = null
      if (Array.isArray(items)) {
        this.selected = ''// this.placeholder
        if (items.length) {
          if (this.isLabelMode) {
            // 标签模式：显示已选标签名称（WZPE-47316）
            const names = (this.originItems || []).filter(item => (items || []).map(String).includes(String(item[this.props.value]))).map(item => item[this.props.label])
            this.selected = names.join('、') || `${items.length}项已选择`
          } else {
            this.selected = `${items.length}项已选择`
          }
        }
        _data = items
        if (this.checkedValues.length !== items.length) { // 针对营销方案 保司Tag显示操作
          this.checkedValues = items
        }
      } else {
        _data = items[this.props.value]
        this.selected = items[this.props.label]
      }
      // this.$emit('update:checked', _data)
      emit && this.$emit('change', _data)
    },
    handleCheckAllChange (val) {
      // console.log('this.checkedValues = ', this.checkedValues)
      let items = (this.isFilter || this.props.disabled) ? this.filterResult : this.originItems
      // this.checkedValues = val ? items.map(item => item[this.props.value]) : []
      const checkedValues = items.map(item => item[this.props.value])
      if (val) {
        const _checkedValues = checkedValues.filter(item => !this.checkedValues.includes(item))
        const merged = [...this.checkedValues, ..._checkedValues] // [...checkedValues]
        // 超出可选上限：本次全选不生效（勾选框回退，已选项保持不变）
        if (this.isOverMax(merged.length)) {
          this.rejectOverMax(merged.length)
          return
        }
        this.checkedValues = merged
      } else {
        // 仅取消「当前搜索/筛选范围」内的选中项，保留范围外的已选（原逻辑会清空全部）
        this.checkedValues = this.checkedValues.filter(item => !checkedValues.includes(item))
      }
      this.lastValidValues = [...this.checkedValues]
      this.isIndeterminate = false
      this.checkedChange(this.checkedValues)
    },
    handleCheckedChange (value) {
      // 超出可选上限：本次勾选不生效，回退到上一次合法选择
      if (this.isOverMax(value.length)) {
        this.rejectOverMax(value.length)
        return
      }
      let checkedCount = value.length
      let items = (this.isFilter || this.props.disabled) ? this.filterResult : this.originItems
      this.checkAll = checkedCount === items.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < items.length
      this.lastValidValues = [...value]
      this.checkedChange(this.checkedValues)
    },
    initOptions (data) {
      if (!data) {
        return
      }
      this.filterResult = [...data]
      if (this.props.disabled) {
        // this.filterResult = data.filter(item => `${item[this.props.disabled]}` !== `${this.props.disabledValue}`)
        this.filterResult = data.filter(item => !this.judgeDisableStatus(item))
      }
      const options = this.filterResult.filter((item) => this.checkedValues.includes(item[this.props.value]))
      if (options.length >= +this.max) {
        this.options = options.filter((_, index) => index < +this.max)
      } else {
        const excludes = this.filterResult.filter(item => !this.checkedValues.includes(item[this.props.value]))
          .filter((_, index) => index < +this.max - options.length)
        this.options = [...options, ...excludes]
      }
    },
    initCheckedOptions (checked) {
      if (checked && checked.length > 0) {
        const field = this.props.value
        const items = Array.isArray(checked) ? checked : checked.split(',')
        let options = this.options.filter(item => items.includes(`${item[field]}`))
        // console.log(options)
        if (!options || options.length === 0 || (options.length < items.length && options < +this.max)) {
          const exists = (options && options.map(item => `${item[field]}`)) || []
          const users = this.originItems.filter(item => `${item[field]}` === `${this.item}` || (items.includes(`${item[field]}`) && !exists.includes(`${item[field]}`)))
          this.options = [...this.options, ...users]
          // console.log('🚀 ~ file: MultiSelect.vue:192 ~ initCheckedOptions ~ this.options', this.options)
        }
      }
    },
    judgeDisableStatus (item) {
      const { disabled, disabledValue } = this.props
      if (typeof disabledValue === 'string') {
        return disabledValue.split(',').includes(`${item[disabled]}`)
      }
      // console.log('judgeDisableStatus2222', disabledValue === item[disabled])
      return disabledValue === item[disabled]
    }
  },
  watch: {
    labelOptions: {
      handler (val) {
        if (val && val.length) this.innerLabelOptions = val
      },
      immediate: true
    },
    'items': function (newVal, oldVal) {
      this.originItems = [...(newVal || [])]
      this.initOptions(newVal)
      const field = this.props.value
      if (this.selectedAll) {
        this.checkedValues = this.originItems.map(item => item[field])
        this.selected = `${this.originItems.length}项已选择`
        this.checkAll = true
      } else {
        // WZPE-47316-F2：选项异步晚到时同样按标签模式显示名称（与 checkedChange 一致）
        const _selectedValues = this.originItems.filter(item => (this.checkedValues || []).map(String).includes(String(item[field])))
        if (this.isLabelMode && _selectedValues.length) {
          this.selected = _selectedValues.map(item => item[this.props.label]).join('、')
        } else {
          this.selected = _selectedValues.length === 0 ? '' : `${_selectedValues.length}项已选择`
        }
      }
    },
    'checked': function (newVal, oldVal) {
      this.checkedValues = [...newVal]
      this.lastValidValues = [...newVal]
      this.initCheckedOptions(newVal)
      this.checkedChange(newVal, false)
      // 外部回滚/重置选择时同步「全选」勾选态，避免与内部勾选列表状态错位（如父组件超限回滚）
      const field = this.props.value
      const checkedSet = new Set((this.checkedValues || []).map(String))
      const allChecked = this.options.length > 0 && this.options.every(item => checkedSet.has(`${item[field]}`))
      this.checkAll = allChecked
      this.isIndeterminate = !allChecked && this.checkedValues.length > 0
    }
  }

}
</script>

<style lang="less" scoped>
.custom-tree {
  &__box {
    padding: 5px 3px;
    // min-width: 200px;
    /* max-width: 530px;
    max-height: 300px;
    overflow: auto; */
    .el-checkbox {
      // width: 100%-10%;
      padding: 5px 0 5px 10px;
      display: block;
    }
    .center {
      min-width: 200px;
    }
    .el-checkbox-group {
      max-width: 530px;
      max-height: 300px;
      overflow: auto;
    }
  }
  &__search {
    padding-bottom: 5px;
  }
  &__delete {
    text-decoration: line-through;
    color: red;
  }
}

.custom-tree__label-filter {
  padding: 4px 8px 8px;
  border-bottom: 1px dashed #e8e8e8;
  margin-bottom: 6px;
}
.custom-tree__label-title {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
}
.custom-tree__label-filter {
  padding: 0 8px 8px;
  border-bottom: 1px dashed #e8e8e8;
  margin-bottom: 6px;
}
.ms-label-group { margin-bottom: 10px; }
.ms-label-group-title { font-size: 12px; font-weight: 600; color: #606266; margin-bottom: 6px; display: flex; align-items: center; justify-content: space-between; }
.ms-label-group-count { color: #909399; font-size: 12px; font-weight: normal; }
.ms-label-opt { display: inline-flex; align-items: center; }
.ms-label-dot { display: inline-block; width: 10px; height: 10px; border-radius: 2px; margin-right: 5px; }
.ms-label-name { color: #303133; }
</style>



// WEBPACK FOOTER //
// src/components/MultiSelect.vue